import type { ReactElement } from 'react';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { getMarkStatusIcon, isMarkFinished } from 'helpers/marking.helpers';
import { markStatusDisplayName } from 'pages/marking/helpers/presentation.helpers';
import { type MarkStatus } from 'services/assist-api/entities/test-instance-response-mark/types';

/**
 * Get classnames to style the mark status, excluding what is defined in the SCSS module.
 */
export const getMarkStatusBootstrapClassNames = (status: MarkStatus): string =>
  isMarkFinished(status) ? 'bg-danger text-dark' : 'bg-success text-light';

export default function MarkStatusWarningBadge({
  children
}: {
  children: MarkStatus;
}): ReactElement {
  return (
    <span
      className={clsx(
        'badge rounded-pill mark-status-badge',
        getMarkStatusBootstrapClassNames(children) // CSS classes from Bootstrap
      )}
    >
      <span className="me-2">{markStatusDisplayName(children)}</span>
      <FontAwesomeIcon icon={getMarkStatusIcon(children)} size="lg" />
    </span>
  );
}
